import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TesteService } from 'src/app/services/teste.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';


@Component({
  selector: 'app-uploadrevisao',
  templateUrl: './uploadrevisao.component.html',
  styleUrls: ['./uploadrevisao.component.scss']
})
export class UploadrevisaoComponent implements OnInit {

    fileToUpload: File | null = null;
    cpf: string;
    form: FormGroup;
    mcpf: string;
    mnome: string;
    marq: string;
    m_tit: string;
    m_tip: string;
    m_filename: string;
    inscricao: any;
    existe: number;
    mostraArquvo: string;

    caminhoArquivosUpload:string;

    formData = new FormData();

    constructor( private fb: FormBuilder, private router: Router, private testeService: TesteService, private http: HttpClient) {

    }

    ngOnInit(): void {

      this.initForm();

      this.m_tit = 'TÍTULO DO DOCUMENTO';

      console.log("xxxxxxx---->>> "+this.testeService.pubtip);


      if (this.testeService.pubtip=='1') {
        this.m_tit = '1- IDENTIDADE';
      }
      if (this.testeService.pubtip=='2') {
        this.m_tit = '2- CPF';
      }
      if (this.testeService.pubtip=='3') {
        this.m_tit = '3- PIS';
      }
      if (this.testeService.pubtip=='4') {
        this.m_tit = '4- COMP. RESIDÊNCIA';
      }
      if (this.testeService.pubtip=='5') {
        this.m_tit = '5- LIBERAÇÃO/QUITAÇÃO SERV. MILITAR';
      }
      if (this.testeService.pubtip=='6') {
        this.m_tit = '6- CONSELHO REGIONAL';
      }
      if (this.testeService.pubtip=='7') {
        this.m_tit = '7- TRANSF CONSELHO REGIONAL';
      }
      if (this.testeService.pubtip=='8') {
        this.m_tit = '8- HISTORICO ESCOLAR';
      }
      if (this.testeService.pubtip=='9') {
        this.m_tit = '9- COMP. EXPERIÊNCIA PROFISSIONAL';
      }
      if (this.testeService.pubtip=='50') {
        this.m_tit = '10- CERT/CERTIDÃO CONCLUSÃO';
      }
      if (this.testeService.pubtip=='51') {
        this.m_tit = '11- INSCRIÇÃO INSS';
      }
      if (this.testeService.pubtip=='52') {
        this.m_tit = '12- QUITAÇÃO ELEITORAL';
      }
      if (this.testeService.pubtip=='53') {
        this.m_tit = '13- CTPS';
      }
      if (this.testeService.pubtip=='54') {
        this.m_tit = '14- COMP. SEGURO DE VIDA';
      }

      console.log("yyyyyy---->>> "+this.m_tit);

      this.m_filename ='';
      this.cpf = this.testeService.pub_cpf;
      this.mnome = this.testeService.pub_nome;
      this.inscricao = this.testeService.pub_inscricao;


     // verifica se tem arquivo e mostra, se tiver
     //IDENTIDADE
     this.testeService.listaDocumento(this.testeService.pubtip).then((data2: any) => {
      console.log("data2.id---->>> "+data2);
      if (data2.id != null) {
        this.fileMostra(this.cpf,this.testeService.pubtip);
       }
      });


     this.testeService.listaInscricao().then((data1: any) => {
       this.mnome=data1.nome;


      //this.existe = this.testeService.ExisteArquivo(this.cpf,'1');
      console.log("+++++++++++++++++++-+-+> 1 ",this.testeService.ExisteArquivo(this.cpf,'1'));

      this.caminhoArquivosUpload= `${environment.caminhoArquivosUpload}`


    });




    }


    initForm() {
      this.form = this.fb.group({
        nome: '',
        //cpf: '',
        file1: '',
        m_tit: '',
        m_tip: this.testeService.pubtip

      });
    }



    get formControls() {
      return this.form.controls;
    }



  fileChange(event, tipo: string) {

      let fileList: FileList = event.target.files;
      if(fileList.length > 0) {

        let file: File = fileList[0];


        this.m_filename = file.name;
        ///this.m_filename = '\' + this.testeService.pub_cpf + '\' + this.m_filename;
        //let formData = new FormData();
        console.log("====>"+this.m_filename);
        console.log("====> upload arq");
        this.formData.append('arquivo', file);
        this.formData.append('caminho', 'Documentos/' + this.testeService.pub_cpf);
        //this.formData.append('caminho',  this.testeService.pub_cpf);        //const url = `${environment.bancoUpload}/uploadArquivo`;

        //this.http.post( url, this.formData).subscribe(resposta => console.log('upload realizado'));

        let nome = this.m_filename;
        let extensao =  nome.substring(nome.length - 4);
        extensao = extensao.toUpperCase();
        let exte = '';


        if (extensao == ".PDF"){


            if (this.testeService.pubtip=="1"){
              exte = this.testeService.pub_cpf +  'IDE.PDF';
              this.form.get("file1").setValue(this.m_filename);
              this.m_filename = exte;
            }


            if (this.testeService.pubtip=="2"){
              exte = this.testeService.pub_cpf +  'CPF.PDF';
              this.form.get("file1").setValue(this.m_filename);
              this.m_filename = exte;
            }

            if (this.testeService.pubtip=="3"){
              exte = this.testeService.pub_cpf +  'PIS.PDF';
              this.form.get("file1").setValue(this.m_filename);
              this.m_filename = exte;
            }

            if (this.testeService.pubtip=="4"){
              exte = this.testeService.pub_cpf +  'RES.PDF';
              this.form.get("file1").setValue(this.m_filename);
              this.m_filename = exte;
            }

            if (this.testeService.pubtip=="5"){
              exte = this.testeService.pub_cpf +  'MIL.PDF';
              this.form.get("file1").setValue(this.m_filename);
              this.m_filename = exte;
            }

            if (this.testeService.pubtip=="6"){
              exte = this.testeService.pub_cpf +  'REG.PDF';
              this.form.get("file1").setValue(this.m_filename);
              this.m_filename = exte;
            }

            if (this.testeService.pubtip=="7"){
              exte = this.testeService.pub_cpf +  'TCR.PDF';
              this.form.get("file1").setValue(this.m_filename);
              this.m_filename = exte;
            }


            if (this.testeService.pubtip=="8"){
              exte = this.testeService.pub_cpf +  'HIS.PDF';
              this.form.get("file1").setValue(this.m_filename);
              this.m_filename = exte;
            }

            if (this.testeService.pubtip=="9"){
              exte = this.testeService.pub_cpf +  'EXP.PDF';
              this.form.get("file1").setValue(this.m_filename);
              this.m_filename = exte;
            }

            if (this.testeService.pubtip=="50"){
              exte = this.testeService.pub_cpf +  'DIP.PDF';
              this.form.get("file1").setValue(this.m_filename);
              this.m_filename = exte;
            }

            if (this.testeService.pubtip=="51"){
              exte = this.testeService.pub_cpf +  'INS.PDF';
              this.form.get("file1").setValue(this.m_filename);
              this.m_filename = exte;
            }

            if (this.testeService.pubtip=="52"){
              exte = this.testeService.pub_cpf +  'ELE.PDF';
              this.form.get("file1").setValue(this.m_filename);
              this.m_filename = exte;
            }

            if (this.testeService.pubtip=="53"){
              exte = this.testeService.pub_cpf +  'CTP.PDF';
              this.form.get("file1").setValue(this.m_filename);
              this.m_filename = exte;
            }

            if (this.testeService.pubtip=="54"){
              exte = this.testeService.pub_cpf +  'SEG.PDF';
              this.form.get("file1").setValue(this.m_filename);
              this.m_filename = exte;
            }


             this.testeService.pubdoc = exte;

             this.formData.append('nomearquivo',  exte);
             console.log("== tipo ==>"+tipo);
             console.log("== m_tip ==>"+this.testeService.pubtip);
             console.log("== exte ==>"+exte);
             console.log("*******************>>>> "+this.testeService.pub_cpf + " ---- " + tipo+ " ---- " + this.m_filename);


            //incluir arquivo na tabela de controle
            this.testeService.InserirArquivo(this.testeService.pub_cpf,this.testeService.pubtip,exte).subscribe(data =>{
              console.log(data);
            }, erro => console.error(erro));

            console.log(this.formData);

            //faz o upload
            const url = `${environment.bancoUpload}/uploadArquivo`;
            this.http.post( url, this.formData).subscribe(resposta => console.log('===== >>> upload realizado'));
            // navega para a tela anterior
            this.router.navigate(['/revisao']);



        }else{
          window.prompt('AVISO','SOMENTE ARQUIVOS FORMATO PDF SÃO PERMITIDOS !');
            // navega para a tela anterior
            this.router.navigate(['/revisao']);
        }
      }
  }


  fileTrans(tipo: string) {

        //incluir arquivo na tabela de controle
        this.testeService.InserirArquivo(this.testeService.pub_cpf,tipo,this.m_filename).subscribe(data =>{
          console.log(data);
        }, erro => console.error(erro));


        //faz o upload
        const url = `${environment.bancoUpload}/uploadArquivo`;
        this.http.post( url, this.formData, ).subscribe(resposta => console.log('upload realizado'));


  }

  fileDelete(id: string, caminho: string, arquivo: string) {

  //excluir arquivo na tabela de controle
  console.log("delete----"+this.testeService.pub_cpf+"---"+id);

  this.testeService.DeletarArquivo(this.testeService.pub_cpf,id).subscribe(data =>{
    console.log(data);
  }, erro => console.error(erro));


  console.log("delete-"+id)
  if (id=="1"){
    this.form.get("file1").setValue('');
    this.m_filename='';
    this.testeService.pubdoc='';
  }

  //Apaga arquivo
  const url = `${environment.bancoUpload}/DeleteArquivo`;
  //caminho +
  this.formData.append('caminho', 'DOCUMENTOS/' + this.testeService.pub_cpf +'/');
  this.formData.append('nomearquivo', arquivo);
  this.http.post( url,this.formData , ).subscribe(resposta => console.log('Arquivo apagado'));

  this.m_filename="";

  }

  //---------------------------

  fileUp(id: string, caminho: string, arquivo: string) {

    // navega para a tela anterior
    this.router.navigate(['/revisao']);

  }

  //---------------------------

  fileMostra(cpf: string, id: string) {

    if (id=="1"){
      this.marq=cpf+'IDE.PDF';
    }
    if (id=="2"){
      this.marq=cpf+'CPF.PDF';
    }
    if (id=="3"){
      this.marq=cpf+'PIS.PDF';
    }
    if (id=="4"){
      this.marq=cpf+'RES.PDF';
    }
    if (id=="5"){
      this.marq=cpf+'MIL.PDF';
    }
    if (id=="6"){
      this.marq=cpf+'REG.PDF';
    }
    if (id=="7"){
      this.marq=cpf+'TCR.PDF';
    }
    if (id=="8"){
      this.marq=cpf+'HIS.PDF';
    }
    if (id=="9"){
      this.marq=cpf+'EXP.PDF';
    }
    if (id=="50"){
      this.marq=cpf+'DIP.PDF';
    }
    if (id=="51"){
      this.marq=cpf+'INS.PDF';
    }
    if (id=="52"){
      this.marq=cpf+'ELE.PDF';
    }
    if (id=="53"){
      this.marq=cpf+'CTP.PDF';
    }
    if (id=="54"){
      this.marq=cpf+'SEG.PDF';
    }


    this.form.get("file1").setValue(this.marq);
    this.m_filename=this.marq;

    this.m_filename="";
    }




  retorna(){
    // navega para a tela de login
    this.router.navigate(['/']);

  }


  }


